const STORAGE_VERSION = 1;

const emptyDetails = () => ({
  instructions: '',
  requis: [],
  fourniGratuit: [],
  fourniPayant: [],
});

export const getEquipementPresets = (categorie) => {
  const key = String(categorie || '').toUpperCase();
  const common = ['Tenue adaptée', 'Chaussures fermées', 'Bouteille d’eau'];
  const byCategory = {
    CENTRE_EQUESTRE: [
      'Bottes d’équitation',
      'Pantalon long',
      'Casque (si non fourni)',
      'Certificat médical',
    ],
    PADEL: ['Raquettes', 'Chaussures de sport', 'Tenue de sport'],
    TENNIS: ['Raquettes', 'Balles', 'Chaussures de tennis'],
    FOOT: ['Chaussures à crampons', 'Tenue de sport', 'Protège-tibias'],
    SALLE_SPORT: ['Tenue de sport', 'Serviette', 'Bouteille d’eau'],
  };
  const fourni = {
    CENTRE_EQUESTRE: ['Casque', 'Bottes', 'Selle', 'Bride et mors', 'Gilet de protection'],
    PADEL: ['Raquettes', 'Balles', 'Serviette'],
    TENNIS: ['Raquettes', 'Balles'],
  };
  return {
    requis: [...(byCategory[key] || common)],
    fourniGratuit: fourni[key] || ['Matériel de base'],
  };
};

export const parsePreparationRequis = (raw) => {
  if (!raw || typeof raw !== 'string') return emptyDetails();
  const trimmed = raw.trim();
  if (!trimmed) return emptyDetails();

  if (trimmed.startsWith('{')) {
    try {
      const data = JSON.parse(trimmed);
      if (data?.v === STORAGE_VERSION) {
        return {
          instructions: typeof data.instructions === 'string' ? data.instructions : '',
          requis: normalizeStringList(data.requis),
          fourniGratuit: normalizeStringList(data.fourniGratuit),
          fourniPayant: normalizePayantList(data.fourniPayant),
        };
      }
    } catch {
      // Texte libre legacy
    }
  }

  return { ...emptyDetails(), instructions: trimmed };
};

export const serializePreparationRequis = ({
  instructions = '',
  requis = [],
  fourniGratuit = [],
  fourniPayant = [],
} = {}) => {
  const payload = {
    v: STORAGE_VERSION,
    instructions: String(instructions || '').trim(),
    requis: normalizeStringList(requis),
    fourniGratuit: normalizeStringList(fourniGratuit),
    fourniPayant: normalizePayantList(fourniPayant),
  };

  const hasStructured =
    payload.requis.length > 0 || payload.fourniGratuit.length > 0 || payload.fourniPayant.length > 0;

  if (!hasStructured && !payload.instructions) return null;
  if (!hasStructured) return payload.instructions;

  return JSON.stringify(payload);
};

export const hasEquipementFourni = ({ equipementFourni, fourniGratuit = [], fourniPayant = [] }) =>
  Boolean(equipementFourni) || fourniGratuit.length > 0 || fourniPayant.length > 0;

const normalizeStringList = (values) => {
  if (!Array.isArray(values)) return [];
  return [...new Set(values.map((v) => String(v || '').trim()).filter(Boolean))];
};

const normalizePayantList = (values) => {
  if (!Array.isArray(values)) return [];
  return values
    .map((row) => ({
      nom: String(row?.nom || '').trim(),
      prix: parseFloat(row?.prix),
    }))
    .filter((row) => row.nom && Number.isFinite(row.prix) && row.prix >= 0);
};
